/**
 * Returns data-testid attribute only in development/test mode.
 * In production, returns an empty object to keep the DOM clean.
 *
 * Usage:
 *   <div {...testId('inquiry-modal')}>
 *   <button {...testId('submit-button')}>
 */
export function testId(id: string): { 'data-testid'?: string } {
  if (import.meta.env.DEV) {
    return { 'data-testid': id };
  }
  return {};
}
